// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","button":"_20qRH","icon":"_1Shiu"};